import { IApplicationState } from '../../types/redux';

export function isEscrowSelector(state: IApplicationState) {
  return state.newbuilding.isEscrow;
}

export function isEscrowHouseSelector(state: IApplicationState) {
  const selectedHouseId = state.offers?.selectedHouseId;

  if (selectedHouseId) {
    const selectedHouse = state.newbuilding.houses.find(house => house.houseId === selectedHouseId);

    return selectedHouse?.isEscrow || false;
  }

  return state.newbuilding.isEscrow;
}
